import { render, staticRenderFns } from "./add-ingredient.vue?vue&type=template&id=03a8b01c&"
import script from "./add-ingredient.vue?vue&type=script&lang=js&"
export * from "./add-ingredient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports